import {Image} from '@app/components/Image';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const LyricsShare: FunctionComponent = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'lyricslandingpage_title_sharelyricswithfriends_standalone-web',
							{ns: 'lyrics'},
						)}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('lyricslandingpage_text_sharelyricswithfriends_standalone-web', {
							ns: 'lyrics',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					quality={90}
					m={{base: '-50px 0 0 0', md: 'auto'}}
					h={{base: '300px', md: '100%'}}
					src="c0e4d1dd7548a42f54a46642be89c81a.png"
					aspectRatio="720/582"
					alt={t('metatag_text_sharelyricsonsocialmedia_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
